<template>
  <div class="processGroup">
    <el-checkbox-group
      v-model="answer"
      size="mini"
      @change="change"
    >
      <el-checkbox
        v-for="option in optionList"
        :key="option.Id"
        :label="option"
        :disabled="defaultValue && defaultValue.some(value => value === option.Id)"
        border
      >
        {{ option.GroupName }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: "processGroup",
  props: {
    optionList: {
      default: () => {
        return [];
      },
    },
    defaultValue: {
      default: () => {
        return [];
      },
    },
  },
  watch: {
    defaultValue: {
      handler() {
        this.computedAnswer();
      },
      immediate: true,
    },
    optionList: {
      handler() {
        this.computedAnswer();
      },
      immediate: true,
    },
  },
  data() {
    return {
      answer: [],
    };
  },
  methods: {
    computedAnswer() {
      const { defaultValue, optionList } = this;
      if (
        Array.isArray(defaultValue) &&
        defaultValue.length > 0 &&
        Array.isArray(optionList) &&
        optionList.length > 0
      ) {
        this.answer = [];
        defaultValue.forEach((item) => {
          const answer = optionList.filter((option) => {
            return item == option.Id;
          });
          this.answer.push(...answer);
        });
        this.$emit("change", this.answer);
        return;
      }
    },
    change(value) {
      this.$emit("change", value);
    },
  },
};
</script>

<style lang="scss">
.processGroup {
  .el-checkbox {
    margin-right: 10px;
    margin-bottom: 10px;
    margin-left: 0 !important;
  }
}
</style>